import { FileFilterOption } from './file-filter-option';
import { Source } from './source.enum';

export class FileFilterList {
  topic: FileFilterOption = new FileFilterOption('Topic', true, Source.Topic);
  storyboard: FileFilterOption = new FileFilterOption('Storyboard', true, Source.Storyboard);
  stadium: FileFilterOption = new FileFilterOption('Stadium', true, Source.Stadium);
  videos: FileFilterOption = new FileFilterOption('Videos', true, Source.Video);
  images: FileFilterOption = new FileFilterOption('Images', true, Source.Image);
  pdfs: FileFilterOption = new FileFilterOption('PDFs', true, Source.PDF);

  constructor(
    topic: boolean,
    storyboard: boolean,
    stadium: boolean,
    videos: boolean,
    images: boolean,
    pdfs: boolean,
  ) {
    this.topic.value = topic;
    this.storyboard.value = storyboard;
    this.stadium.value = stadium;
    this.videos.value = videos;
    this.images.value = images;
    this.pdfs.value = pdfs;
  }

  getKeys(): Array<String> {
    return Object.keys(this);
  }

  setChecked(state: boolean): void {
    Object.keys(this).forEach((key) => this[key].value = state);
  }
}

